import { Link as RouterLink } from 'react-router-dom'
import PropTypes from 'prop-types'

export const Link = ({
  to,
  href,
  variant = 'primary',
  size = 'default',
  underline = false,
  className = '',
  children,
  ...props
}) => {
  const variants = {
    primary: 'text-blue-400 hover:text-blue-300',
    secondary: 'text-gray-400 hover:text-gray-300',
    white: 'text-white hover:text-gray-200',
    footer: 'text-gray-500 hover:text-gray-400',
  }

  const sizes = {
    sm: 'text-sm',
    default: '',
    lg: 'text-lg',
  }

  const baseClasses = `${variants[variant]} ${sizes[size]} transition-colors ${
    underline ? 'underline' : ''
  } ${className}`.trim()

  // Internal link using React Router
  if (to) {
    return (
      <RouterLink to={to} className={baseClasses} {...props}>
        {children}
      </RouterLink>
    )
  }

  // External link using regular anchor
  return (
    <a href={href} className={baseClasses} {...props}>
      {children}
    </a>
  )
}

Link.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'white', 'footer']),
  size: PropTypes.oneOf(['sm', 'default', 'lg']),
  underline: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default Link
